import React from 'react';
import { Layout } from 'react-admin';
import MyAppBar from './MyAppBar';
import AgentChat from './AgentChat';

const MyLayout = (props) => (
    <>
        <Layout {...props} appBar={MyAppBar} />
        <AgentChat />
    </>
);

export default MyLayout;

